// AUTOGENERATED -- DO NOT EDIT

import { OystehrClientRequest, VersionGetResponse } from '../..';
import { SDKResource } from '../../client/client';
import { OystehrConfig } from '../../config';

export class Version extends SDKResource {
  constructor(config: OystehrConfig) {
    super(config);
  }
  #baseUrlThunk(): string {
    return this.config.services?.['projectApiUrl'] ?? 'https://project-api.zapehr.com/v1';
  }
  /**
   * Get project API version. This endpoint is public so there are no access policy requirements.
   */
  get(request?: OystehrClientRequest): Promise<VersionGetResponse> {
    return this.request('/version', 'get', this.#baseUrlThunk.bind(this))(request);
  }
}
